import React, { useEffect, useState, createElement } from 'react';
import { LoadingAnimation } from './components/LoadingAnimation';
import { Hero } from './components/Hero';
import { Philosophy } from './components/Philosophy';
import { MenuSection } from './components/MenuSection';
import { WhyBajoPerfil } from './components/WhyBajoPerfil';
import { Footer } from './components/Footer';
const TITLE = 'BAJO PERFIL — Menú';
const DESCRIPTION = 'Street food premium. Kebabs y papas horneadas. Pasto, Colombia.';
function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
function usePageMeta() {
  useEffect(() => {
    document.title = TITLE;
    upsertMeta('name', 'description', DESCRIPTION);
    upsertMeta('property', 'og:title', TITLE);
    upsertMeta('property', 'og:description', DESCRIPTION);
    upsertMeta('property', 'og:url', 'https://bajoperfil.online');
    upsertMeta('property', 'og:site_name', 'BAJO PERFIL');
  }, []);
}
export function App() {
  const [loading, setLoading] = useState(true);
  usePageMeta();
  return <div className="w-full min-h-screen bg-bp-bg" data-id="element-0" data-mp="5yj0slx59ec">
      {loading && <LoadingAnimation onComplete={() => setLoading(false)} data-id="element-1" data-mp="5gbv0xpxarn" />}

      {/* The page sits underneath the loading overlay and is revealed after the
                black overlay bridges in (~3.8s). */}
      <Hero revealDelay={3.8} data-id="element-2" data-mp="33n6w6z5pbl2q" />
      <Philosophy data-id="element-3" data-mp="38lrnua6w0wfk" />

      {/* Fixed tab bar + a single content zone that swaps categories in place */}
      <MenuSection data-id="element-4" data-mp="3dkuvm2e95gr8" />

      <WhyBajoPerfil data-id="element-5" data-mp="3dl4mrtb19tyi" />
      <Footer data-id="element-6" data-mp="3dlnru9fl4nv4" />
    </div>;
}